import type { ReactNode } from "react"
import UsageReportCard, {
  type UsageReportCardProps,
} from "@/v2-backoffice-client/usage/report/UsageReportCard"

export type UsageReportProseProps = Omit<UsageReportCardProps, "children"> & {
  /**
   * The paragraphs, already written: each is a few plain sentences derived
   * from the numbers on the page. Empty paragraphs are skipped so a
   * generator can hand over optional ones.
   */
  paragraphs: ReactNode[]
}

/**
 * A card of prose: the report's way of telling the reader what the
 * numbers mean ("Claude dominates at every large customer. Claude Code is
 * used alongside the Claude app at 25 customers…"). Sentences, not bullets:
 * a sales or CS colleague can lift a paragraph straight into an e-mail.
 */
function UsageReportProse(props: UsageReportProseProps) {
  const { paragraphs, ...cardProps } = props
  const visible = paragraphs.filter(
    (paragraph) => paragraph != null && paragraph !== false && paragraph !== "",
  )
  if (visible.length === 0) return null

  return (
    <UsageReportCard {...cardProps}>
      <div className="usage-report-prose">
        {visible.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>
    </UsageReportCard>
  )
}

export default UsageReportProse
